import {get} from '@yandex-delivery/utils'

export const desktopComponents = {
  datepicker: import('@yandex-delivery/blocks/datepicker/DatePicker').then(get('DatePicker')),
  'datepicker-range': import('@yandex-delivery/blocks/datepicker/DatePicker').then(get('RangeDatePicker')),
  'datepicker-range-querysynced': import('@yandex-delivery/blocks/datepicker/QuerySynced').then(
    get('QuerySyncedRangeDatePicker'),
  ),
  '@form/datepicker-range': import(
    '@yandex-delivery/nlf-form/src/components/range-date-picker/desktop/RangeDatePicker'
  ).then(get('RangeDatePicker')),
  '@form-v2/datepicker-range': import(
    '@yandex-delivery/nlf-form/v2/components/range-date-picker/desktop/RangeDatePicker'
  ).then(get('RangeDatePicker')),
} as const

export const mobileComponents = {
  datepicker: import('@yandex-delivery/blocks/datepicker/DatePicker@mobile').then(get('DatePickerMobile')),
  'datepicker-range': import('@yandex-delivery/blocks/datepicker/DatePicker@mobile').then(
    get('RangeDatePickerMobile'),
  ),
  'datepicker-range-querysynced': import('@yandex-delivery/blocks/datepicker/QuerySynced@mobile').then(
    get('QuerySyncedRangeDatePickerMobile'),
  ),
  '@form/datepicker-range': import(
    '@yandex-delivery/nlf-form/src/components/range-date-picker/mobile/RangeDatePicker'
  ).then(get('RangeDatePicker')),
  '@form-v2/datepicker-range': import(
    '@yandex-delivery/nlf-form/v2/components/range-date-picker/mobile/RangeDatePicker'
  ).then(get('RangeDatePicker')),
} as const
